import { Injectable } from '@angular/core';
import { RoutePathBuilder } from '@ngspot/route-path-builder';
import { ACCOUNT, MY } from './route-strings';
import { RoutesForAccount } from './routes-for-account';
import { RoutesForMy } from './routes-for-my';

@Injectable({ providedIn: 'any' })
export class PdRoutes extends RoutePathBuilder {
  _router = this.router;
  account = this.childRoutes(ACCOUNT.ROOT, RoutesForAccount);
  my = this.childRoutes(MY.ROOT, RoutesForMy);
}
